export default __webpack_public_path__ + "7cb9a0b0c284ec9c8ef9f0b85eff8f8c.svg";